import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface CookieConsentContextType {
  openCookiePreferences: () => void;
  closeCookiePreferences: () => void;
  isPreferencesOpen: boolean;
}

const CookieConsentContext = createContext<CookieConsentContextType | null>(null);

export const useCookieConsentContext = () => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsentContext must be used within CookieConsentProvider');
  }
  return context;
};

export const CookieConsentProvider = ({ children }: { children: ReactNode }) => {
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);

  const openCookiePreferences = useCallback(() => {
    setIsPreferencesOpen(true);
  }, []);

  const closeCookiePreferences = useCallback(() => {
    setIsPreferencesOpen(false);
  }, []);

  return (
    <CookieConsentContext.Provider value={{ openCookiePreferences, closeCookiePreferences, isPreferencesOpen }}>
      {children}
    </CookieConsentContext.Provider>
  );
};
